/** @jsxImportSource theme-ui */
import { createContext } from "react";
import { theme } from "../theme";

/**
 * Context used to manage the layering of z-indexes of components.
 */
const StackingContext = createContext(theme.stackingOrder.STACKING_CONTEXT);
export default StackingContext;
